<div class="app-alert display-flex">
    <loader *ngIf="!showForm"></loader>
    <div *ngIf="showForm" class="app-alert__box bg-light box-shadow app-alert__box--padding">
        <div class="app-alert__message app-alert__message--block font-14 cursor-default">
             {{ subtitle(1931) }}
        </div>
        <div>
            <input type="text"
                   class="login-box__text-input border-input color-basic font-16 font-regular"
                   name="username"
                   [(ngModel)]="email"
                   placeholder="{{ subtitle(1110) | lowercase }}"
                   [disabled]="user.user_id !== 0" />

            <div class="app-alert__buttons-box">
                <div *ngIf="showLoader" class="tiles-list-item__loading">
                    <loader></loader>
                </div>
                <button *ngIf="!showLoader"
                        class="app-alert__button bg-ok color-light font-bold font-14 cursor-pointer"
                        (click)="goBack()">
                    {{ subtitle(71) }}
                </button>
                <input type="button"
                       value="{{ subtitle(3806) }}"
                       *ngIf="!showLoader"
                       class="app-alert__button bg-cancel color-light font-bold font-14 cursor-pointer"
                       (click)="deleteAccount()" />
            </div>
        </div>
    </div>
</div>
